module.exports = __webpack_public_path__ + "static/media/well.bf96fd48.JPG";